import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { CommonForm } from 'src/views/components'
import { formInput } from './formInput'
import { getRecipientSchema } from './validationSchema'

const RecipientDetails = ({ initialValues = {}, onChange }) => {
  const schema = useMemo(() => getRecipientSchema(), [])
  const formInputJson = useMemo(
    () => formInput({ initialValues }),
    [initialValues]
  )

  const handleFormValuesOnChange = ({ values, isFormValid }) => {
    onChange?.({ isValid: isFormValid, values })
  }

  return (
    <div className="recipient-details-form mt-3">
      <CommonForm
        schema={schema}
        formTypeJson={formInputJson}
        hasInlineSubmitButton={true}
        enableReinitialize={false}
        getFormValuesOnChange={handleFormValuesOnChange}
      />
    </div>
  )
}

RecipientDetails.propTypes = {
  initialValues: PropTypes.object,
  onChange: PropTypes.func,
}

export { RecipientDetails }
export default RecipientDetails
